import { Box, Typography } from "@mui/material";
import { useState } from "react";
import IconButton from "../../../../../../../components/buttons/IconButton";
import SearchInput from "../../../../../../../components/filters/SearchInput";
import { getPrettyDate } from "../../../../../../../utils/timestamp";
import { csvExportFile } from "../../../../../../posture/controls/components/EntitiesSection/ExportTable";

import StyledDataGrid from "../../../../../../../components/StyledDataGrid";
import IntegrationImage from "../../../../../integrations/components/IntegrationImage";
import { icons } from "../../../../icons/iconExport";

export default function LocalUsersSection({ localUsers, notFoundMessage }) {
  const [appliedFilters, setAppliedFilters] = useState({
    searchString: "",
  });

  const filteredLocalUsers = localUsers.filter((localUser) =>
    (localUser.username ?? "")
      .toLowerCase()
      .includes(appliedFilters.searchString.toLowerCase())
  );

  const columns = [
    {
      field: "username",
      headerName: "Username",
      minWidth: 125,
      flex: 1.5,
      renderCell: (params) => (
        <Typography variant="caption">
          {params?.value || "Unknown User"}
        </Typography>
      ),
    },
    {
      field: "lastSeenTimestamp",
      headerName: "Seen At",
      minWidth: 105,
      flex: 1,
      renderCell: (params) => (
        <Typography variant="caption">
          {getPrettyDate(params?.value)}
        </Typography>
      ),
    },
    {
      field: "sources",
      headerName: "Source",
      minWidth: 105,
      flex: 1,
      renderCell: (params) => (
        <Box display="flex" flexDirection="row" gap={1}>
          {params?.value?.map((source) => (
            <IntegrationImage
              key={source}
              name={source}
              width={"24px"}
              style={{ margin: "16px" }}
              newLogo={true}
            />
          ))}
        </Box>
      ),
    },
  ];

  const handleExport = () => {
    if (!filteredLocalUsers.length) {
      return;
    }

    const headers = ["Username", "Seen At", "Sources"];
    const rows = filteredLocalUsers.map((localUser) => [
      localUser.username ?? "Unknown User",
      getPrettyDate(localUser.last_seen_timestamp),
      localUser.sources ?? "-",
    ]);

    csvExportFile([headers, ...rows], "local_users");
  };

  return (
    <>
      {localUsers && localUsers.length > 0 ? (
        <Box display="flex" flexDirection="column" gap={2}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="space-between"
          >
            <SearchInput
              fieldName="searchString"
              appliedFilters={appliedFilters}
              setAppliedFilters={setAppliedFilters}
              width="300px"
            />
            <IconButton
              onClick={handleExport}
              IconSVG={icons.ActionDownloadIcon}
              sx={{
                height: "32px",
                width: "32px",
              }}
              color="inherit"
            />
          </Box>
          <Box>
            <StyledDataGrid
              rows={filteredLocalUsers}
              columns={columns}
              getRowId={(row) => row.username}
            />
          </Box>
        </Box>
      ) : (
        <Typography variant="body2">
          {notFoundMessage || "No local users found"}
        </Typography>
      )}
    </>
  );
}
